import React, { useEffect, useState } from 'react';
import { Routes, Route } from "react-router-dom";


import { HomePage } from "./pages/Home";
import { LoginPage } from "./pages/Login";
import { SettingsPage } from "./pages/Settings";


import { AuthProvider } from "./hooks/useAuth";
import { GroudFloorPage } from './pages/GroundFloor';
import { FirstFloorPage } from './pages/FirstFloor';
import { HistoryPage } from './pages/History';
import { FramePage } from './pages/Frame';


function PageTitle() {
  useEffect(() => {
    document.title = 'ZumaView';
  }, []);
}


function App() {

  PageTitle()

  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/" element={<FramePage />}>
          <Route index element={<HomePage />}></Route>
          <Route path="home" element={<HomePage />}></Route>
          <Route path="groundfloor" element={<GroudFloorPage />}></Route>
          <Route path="firstfloor" element={<FirstFloorPage />}></Route>
          <Route path="settings" element={<SettingsPage />}></Route>
          <Route path="history" element={<HistoryPage />}></Route>
        </Route>
      </Routes>
    </AuthProvider>
  );
};

export default App;

